import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import OperationalHours from "signoxe/components/OperationalHours";
import { actions as notifActions } from "redux-notifications";
const { notifSend } = notifActions;
import {
  addSchedule,
  addSpecialContent,
  bulkUpdateSchedule,
  confirmationRequest,
  enableDeviceGroupSchedule,
  setPageTitle,
  updateContentFeed,
  updateSchedule,
  updateSpecialContent,
  addDailySchedule,
  updateDailySchedule,
  bulkUpdateDailySchedule,
} from "../../actions";
import {
  DEVICE_GROUPS_RESOURCE,
  SCHEDULED_CONTENT_RESOURCE,
  SPECIAL_CONTENT_RESOURCE,
  SCHEDULED_DAILY_CONTENT_RESOURCE,
} from "../../api/resources";
import { Page, ScheduleView, DailyScheduleView, SpecialContentView } from "../../components";
import Button from "../../components/widgets/Button";
import {
  getDeviceGroup,
  getDeviceGroupWraper,
  getDeviceGroups,
  getFeatureStatus,
  processScheduleForBulkUpdate,
} from "../../selectors";
import { WeekDays } from "../../utils/weekdays";
import { getProfile } from "../../selectors/profile";

class DeviceSchedulePage extends Component {
  static propTypes = {
    notifSend: PropTypes.func.isRequired,
    addSchedule: PropTypes.func.isRequired,
    updateSchedule: PropTypes.func.isRequired,
    addSpecialContent: PropTypes.func.isRequired,
    bulkUpdateSchedule: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    enableDeviceGroupSchedule: PropTypes.func.isRequired,
    match: PropTypes.object,
    setPageTitle: PropTypes.func.isRequired,
    deviceGroup: PropTypes.object.isRequired,
    updateContentFeed: PropTypes.func.isRequired,
    updateSpecialContent: PropTypes.func.isRequired,
    smartBoardEnabled: PropTypes.bool,
    profile: PropTypes.array.isRequired,
    addDailySchedule: PropTypes.func.isRequired,
    updateDailySchedule: PropTypes.func.isRequired,
    bulkUpdateDailySchedule: PropTypes.func.isRequired,
  };

  handleDeviceGroupScheduleEnable = () =>
    this.props.enableDeviceGroupSchedule(this.props.deviceGroup);

  handleDisableScheduling = () =>
    this.props.confirmationRequest(
      "Disabling Scheduling",
      `Disabling scheduling for the group "${this.props.deviceGroup.name} is a permanent action and
      cannot be undone. It will remove the weekly schedule but special content will still be in
      effect and needs to be removed separately.`,
      "DISABLE_SCHEDULING",
      DEVICE_GROUPS_RESOURCE,
      parseInt(this.props.match.params.id, 10)
    );

  handleReschedule = (schedule) =>
    this.props.bulkUpdateSchedule(processScheduleForBulkUpdate(schedule));

  handleScheduleFeedChange = (id, newFeed) =>
    this.props.updateContentFeed(id, newFeed);

  handleScheduleTimeSlotAdd = (timeSlot) =>
    this.props.addSchedule({
      ...timeSlot,
      device_group: this.props.match.params.id,
    });

  handleScheduleTimeSlotDelete = (timeSlot) =>
    this.props.confirmationRequest(
      "Deleting Time Slot",
      "This action cannot be undone.",
      "DELETE",
      SCHEDULED_CONTENT_RESOURCE,
      timeSlot.id
    );

  handleScheduleTimeSlotUpdate = (newVal) =>
    this.props.updateSchedule(newVal.id, {
      ...newVal,
      device_group: this.props.match.params.id,
    });

  handleSpecialContentAdd = (specialContent) =>
    this.props.addSpecialContent({
      ...specialContent,
      device_group: this.props.match.params.id,
    });

  handleSpecialContentChange_from = (specialContent) =>
    this.props.updateSpecialContent(specialContent.id, {
      id: specialContent.id,
      dateTime_from: specialContent.dateTime_from,
    });

  handleSpecialContentChange_to = (specialContent) =>
    this.props.updateSpecialContent(specialContent.id, {
      id: specialContent.id,
      dateTime_to: specialContent.dateTime_to,
    });

  handleSpecialContentDelete = (specialContent) =>
    this.props.confirmationRequest(
      "Deleting special content",
      "This action cannot be undone.",
      "DELETE",
      SPECIAL_CONTENT_RESOURCE,
      specialContent.id
    );

  // handling daily schedule
  handleDailyReschedule = (schedule) =>
    this.props.bulkUpdateDailySchedule(processScheduleForBulkUpdate(schedule));

  handleDailyScheduleTimeSlotUpdate = (newVal) =>
    this.props.updateDailySchedule(newVal.id, {
      ...newVal,
      device_group: this.props.match.params.id,
    });

  handleDailyScheduleTimeSlotAdd = (timeSlot) =>
    this.props.addDailySchedule({
      ...timeSlot,
      device_group: this.props.match.params.id,
    });

  handleDailyScheduleTimeSlotDelete = (timeSlot) =>
    this.props.confirmationRequest(
      "Deleting Time Slot",
      "This action cannot be undone.",
      "DELETE",
      SCHEDULED_DAILY_CONTENT_RESOURCE,
      timeSlot.id
    );

  componentDidMount() {
    if (this.props.deviceGroup) {
      this.props.setPageTitle(
        `Schedule for Group ${this.props.deviceGroup.name}`
      );
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.deviceGroup) {
  //     this.props.setPageTitle(`Schedule for Group ${nextProps.deviceGroup.name}`);
  //   }
  // }

  getScheduleDisabledView() {
    return (
      <div className="disabled">
        <h2>Weekly Scheduling Disabled</h2>
        <p style={{ maxWidth: "100%" }}>
        Enabling weekly scheduling allows you to change content daywise. 
        Weekly scheduling takes priority over daily schedule.
        Note that default playlist setup in device group's manage content is applied incase no timeslot is defined.
        </p>
        <Button onClick={this.handleDeviceGroupScheduleEnable}>
          Enable Weekly Scheduling
        </Button>
      </div>
    );
  }

  render() {
    if (this.props.deviceGroup === undefined) {
      return <Page>Loading ...</Page>;
    }
    const { id } = this.props.match.params;

    return (
      <Page>
        <OperationalHours
          groupId={id}
          device={this.props.deviceGroup.devices[0]}
        />
        <SpecialContentView
          notifSend={this.props.notifSend}
          profile={this.props.profile}
          specialContent={this.props.deviceGroup.specials}
          deviceGroup={this.props.deviceGroup}
          onSpecialContentAdd={this.handleSpecialContentAdd}
          onSpecialContentChange_from={this.handleSpecialContentChange_from}
          onSpecialContentChange_to={this.handleSpecialContentChange_to}
          onSpecialContentFeedChange={this.handleScheduleFeedChange}
          onSpecialContentDelete={this.handleSpecialContentDelete}
        />
        {this.props.deviceGroup.schedule.present && <h3>Weekly Schedule:</h3>}
        <>
          <DailyScheduleView
            notifSend={this.props.notifSend}
            profile={this.props.profile}
            key={'daily'}
            day={'daily'}
            deviceGroup={this.props.deviceGroup}
            schedule={this.props.deviceGroup.daily_schedule}
            onReschedule={this.handleDailyReschedule}
            smartBoardEnabled={this.props.smartBoardEnabled}
            onScheduleFeedChange={this.handleScheduleFeedChange}
            onAddScheduleTimeSlot={this.handleDailyScheduleTimeSlotAdd}
            onUpdateScheduleTimeSlot={this.handleDailyScheduleTimeSlotUpdate}
            onScheduleTimeSlotDelete={this.handleDailyScheduleTimeSlotDelete}
          />
        </>
        {this.props.deviceGroup.schedule.present &&
          WeekDays.daysShort.map((day) => (
            <ScheduleView
              profile={this.props.profile}
              key={day}
              day={day}
              deviceGroup={this.props.deviceGroup}
              schedule={this.props.deviceGroup.schedule[day]}
              onReschedule={this.handleReschedule}
              smartBoardEnabled={this.props.smartBoardEnabled}
              onScheduleFeedChange={this.handleScheduleFeedChange}
              onAddScheduleTimeSlot={this.handleScheduleTimeSlotAdd}
              onUpdateScheduleTimeSlot={this.handleScheduleTimeSlotUpdate}
              onScheduleTimeSlotDelete={this.handleScheduleTimeSlotDelete}
            />
          ))}
        {this.props.deviceGroup.schedule.present ? (
          <p style={{ maxWidth: "100%" }}>
            The devices in the group{" "}
            <strong>{this.props.deviceGroup.name}</strong> will receive content
            according to the schedule below. If you want to revert to a simple
            content feed for this device group click the button below.
            <Button onClick={this.handleDisableScheduling} className="alert">
              Disable Weekly Scheduling
            </Button>
          </p>
        ) : (
          this.getScheduleDisabledView()
        )}
      </Page>
    );
  }
}

export default connect(
  (state, { match }) => ({
    deviceGroup: getDeviceGroup(state, parseInt(match.params.id, 10)) == undefined? getDeviceGroupWraper(state, parseInt(match.params.id, 10)) : getDeviceGroup(state, parseInt(match.params.id, 10)),
    smartBoardEnabled: getFeatureStatus(state, "smart_notice_board"),
    groups: getDeviceGroups(state),
    profile: getProfile(state),

  }),
  {
    addSchedule,
    updateSchedule,
    addSpecialContent,
    bulkUpdateSchedule,
    enableDeviceGroupSchedule,
    confirmationRequest,
    setPageTitle,
    updateContentFeed,
    updateSpecialContent,
    addDailySchedule,
    updateDailySchedule,
    bulkUpdateDailySchedule,
    notifSend,
  }
)(DeviceSchedulePage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DeviceSchedulePage/index.js